import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import {  BrowserRouter } from 'react-router-dom';
import PWAPrompt from 'react-ios-pwa-prompt'


createRoot(document.getElementById("root")).render(
  <StrictMode>

  <Provider store={store}>
  <BrowserRouter basename={process.env.PUBLIC_URL}>
<App /><PWAPrompt  
promptOnVisit={1} timesToShow={5}
copyTitle="ERB Accounting System" 
appIconPath='BusinessLogo.png'

 />
</BrowserRouter>
</Provider> 
</StrictMode>
);
// 🌟 Add this right here to activate your caching engine!
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/icon-cache-sw.js`)
      .then(registration => {
        console.log('Icon Cache Engine Running! Scope:', registration.scope);
      })
      .catch(error => {
        console.error('ServiceWorker registration failed:', error);
      });
  });
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

